import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faFistRaised,
  faTrophy,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const HowItWorks = ({ handleGetStarted }) => {
  const steps = [
    {
      number: 1,
      icon: faFistRaised,
      title: "Build Your Lineup",
      description:
        "Select your fighters from upcoming UFC events. Choose wisely based on matchups, stats, and your strategy.",
      color: "bg-deep-red",
    },
    {
      number: 2,
      icon: faTrophy,
      title: "Compete Globally or Privately",
      description:
        "Join the global competition to face everyone, or create private leagues to compete with friends and family.",
      color: "bg-gold",
    },
    {
      number: 3,
      icon: faUsers,
      title: "Climb the Rankings",
      description:
        "Earn points as your fighters perform. Watch live, track your score, and rise to the top of the leaderboard.",
      color: "bg-deep-red",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-dark-grey">
            How DayShift Fantasy
            <span className="block text-gold">Works</span>
          </h2>
          <p className="text-medium-grey text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed">
            Getting started with DayShift Fantasy MMA is easy. Follow these
            simple steps to begin your fantasy MMA journey.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-12 md:space-y-0 md:grid md:grid-cols-3 md:gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center md:text-left">
              {/* Step number and icon */}
              <div className="flex items-center justify-center md:justify-start mb-6">
                <div
                  className={`w-16 h-16 ${step.color} rounded-xl flex items-center justify-center text-white text-2xl font-bold shadow-lg mr-4`}
                >
                  {step.number}
                </div>
                <div className="w-12 h-12 bg-light-grey/20 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={step.icon}
                    className="text-medium-grey text-xl"
                  />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-dark-grey mb-4">
                {step.title}
              </h3>
              <p className="text-medium-grey leading-relaxed text-lg">
                {step.description}
              </p>

              {/* Connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-20 w-full h-0.5 bg-gradient-to-r from-light-grey to-transparent"></div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-light-grey/20 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-dark-grey mb-4">
            Ready to Get Started?
          </h3>
          <p className="text-medium-grey text-lg mb-6 max-w-2xl mx-auto">
            Join now and start competing in fantasy MMA today.
          </p>
          <Button
            onClick={handleGetStarted}
            variant="primary"
            size="lg"
            icon={faArrowRight}
            iconPosition="right"
            className="shadow-xl"
          >
            Get Started
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
